import { render, staticRenderFns } from "./ApmsRegUtilityBill.vue?vue&type=template&id=012865a0&scoped=true&"
import script from "./ApmsRegUtilityBill.vue?vue&type=script&lang=js&"
export * from "./ApmsRegUtilityBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012865a0",
  null
  
)

export default component.exports